"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actionUtils = require("../../../utils/actionUtils");
var _background = require("../../../actions/background");
function backgroundLiveToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var backgroundId = _ref2.backgroundId,
    notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _background.syncBackgroundStatus)(backgroundId));
  }
}
var _default = exports["default"] = backgroundLiveToggled;